"use strict";

var _interopRequireDefault = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _classCallCheck2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _moment = _interopRequireDefault(require("moment"));
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = require("./index.vue");
var ImportTable = /*#__PURE__*/function (_Vue) {
  function ImportTable() {
    var _this;
    (0, _classCallCheck2.default)(this, ImportTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ImportTable, [].concat(args));
    (0, _defineProperty2.default)(_this, "data", void 0);
    (0, _defineProperty2.default)(_this, "total", void 0);
    (0, _defineProperty2.default)(_this, "query", void 0);
    (0, _defineProperty2.default)(_this, "loading", void 0);
    (0, _defineProperty2.default)(_this, "onClickRow", void 0);
    (0, _defineProperty2.default)(_this, "ImportStatus", _index.ImportStatus);
    return _this;
  }
  (0, _inherits2.default)(ImportTable, _Vue);
  return (0, _createClass2.default)(ImportTable, [{
    key: "formatDateDuration",
    value: function formatDateDuration(date) {
      return _moment.default.duration(date, "seconds").humanize(true);
    }
  }, {
    key: "handleSelectionChange",
    value: function handleSelectionChange(val) {
      this.$emit("handleSelection", val);
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ImportTable.prototype, "data", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: 0
})], ImportTable.prototype, "total", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ImportTable.prototype, "query", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], ImportTable.prototype, "loading", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ImportTable.prototype, "onClickRow", void 0);
ImportTable = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], ImportTable);
var _default = exports.default = ImportTable;